import { store } from '@/common/root';
import { VhsNode } from '@schema';
import Node from '@/common/models/node.model';
import { VHS_NODES_STATUS_ICON, VHS_NODES_STATUS_TEXT } from '@/common/constants/vhsNodes.constants';
import { BYTES_IN_GIBIBYTES } from '@/common/utils/formatter.number';

// NOTE(bram.dingelstad) Node responses carry the VHS-native flat fields; the nested `default_datastores`
// exists only in the add/update request schemas (VSTOR-137656).
type VhsNodeResponse = VhsNode & { default_ve_datastore_uuid?: string; backup_datastore_uuid?: string };

export default function VhsNodeMapper(node: VhsNodeResponse) {
  const infrastructureNode: Node | undefined = store.getters['nodes/getItemById'](node.id);
  const isDeletable = node.status === 'CONFIGURED' || node.status === 'ERROR';

  return {
    ...node,
    defaultVeDatastoreId: node.default_ve_datastore_uuid ?? node.default_datastores?.ves ?? null,
    defaultBackupDatastoreId: node.backup_datastore_uuid ?? node.default_datastores?.backups ?? null,
    name: node.name || infrastructureNode?.name,
    isOnline: infrastructureNode?.isOnline,
    statusText: VHS_NODES_STATUS_TEXT[node?.status],
    statusIcon: VHS_NODES_STATUS_ICON[node?.status],
    ips: infrastructureNode?.ipAddressesList,
    vcpus: 4,
    ram: 24 * BYTES_IN_GIBIBYTES,
    isDeletable,
    isSelectable: isDeletable
  };
}

export type VhsNodeMapped = ReturnType<typeof VhsNodeMapper>;
